import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeComponent} from './home.component';
import {RouterModule} from '@angular/router';
import {routes} from './home.routes';
import {CoreModule} from '../core/core.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule.forChild(routes),
        MatProgressSpinnerModule,
        HomeComponent
    ]
})
export class HomeModule {
}
